import React, { useEffect, useRef } from 'react';
import Modal from '@gr-monorepo/common/ui/Modal';
import { Actions, Close, Copied, GrayZone, Header, Main, ModalWindow, TitleMain, Text } from './styled';
import { Button, Space } from '@gr-monorepo/common/ui';
import { ReactComponent as Copy } from './copy.svg';
import copy from 'copy-to-clipboard';
import { useClickStreamContext } from '../ClickStream';


const getTextPopup = (text: string) => {
  const newStr = text?.replace(/<a[^>]*>(.*?)<\/a>/, (match, group1) => {
    const href = match.match(/href="([^"]*)"/);
    return `<a href="${href && href[1]}">${group1.split('?')[0]}</a>`;
  });
  return newStr;
}

const getCopyText = (text: string, textPopup: string) => {
  const match = textPopup.match(/href="([^"]*)"/) || [];
  const href = match && match[1];
  const copyText = text.replace(/https:\/\/[^\s]+/g, href);
  return copyText;
}
const RatingImproveResultPopup = (props: {
  title?: string;
  text: string;
  eventPrefix: string;
  eventTitlePrefix: string;
  onClose: () => void;
  headerColor: string;
}) => {
  console.log('!!!!!!');
  const { logPageEvent } = useClickStreamContext();
  const log = (e: { eventInfo: string; eventType: string }) =>
    logPageEvent({
      eventInfo: `${props.eventTitlePrefix}: ${e.eventInfo}`,
      eventType: `${props.eventPrefix}_${e.eventType}`,
    });

  const ref = useRef<HTMLDivElement>(null);
  const [copied, setCopied] = React.useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copied) setCopied(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [copied]);

  useEffect(() => {}, []);
 const textPopup = getTextPopup(props.text);
 
  return (
    <Modal
      customModalWindow={ModalWindow}
      hiddenCloseCross
      onClose={() => {
        log({ eventInfo: 'Клик по вне попапа (закрытие)', eventType: `click_outside_close` });
        props.onClose();
      }}
    >
      <Header style={{ background: props.headerColor }}>
        {props.title || 'УЛУЧШИТЬ РЕЗУЛЬТАТ'}{' '}
        <Close
          onClick={() => {
            log({ eventInfo: 'Клик по кнопке закрытия', eventType: `click_crose_close` });
            props.onClose();
          }}
        />
      </Header>
      <Main>
        <TitleMain>Скопируйте сообщение и отправьте его школам муниципалитета</TitleMain>
        <Space size={16} axis="vertical" />
        <GrayZone>
          <Text dangerouslySetInnerHTML={{ __html: textPopup }} ref={ref}></Text>
          <Space size={24} axis="vertical" />
          <Actions>
            <Button
              color="white"
              style={{ color: 'rgba(18, 183, 231, 1)', border: '1px solid  #12B7E7' }}
              onClick={() => {
                log({ eventInfo: 'Клик по кнопке скопировать', eventType: `click_copy` });
                copy(getCopyText(ref.current?.innerText || '', textPopup));
                setCopied(true);
              }}
            >
              <Copy />
              СКОПИРОВАТЬ
            </Button>
            {copied && <Copied>СКОПИРОВАно</Copied>}
          </Actions>
        </GrayZone>
      </Main>
    </Modal>
  );
};

export default RatingImproveResultPopup;

// when 'wa'
//       "whatsapp://send?text=#{ERB::Util.url_encode(text)}%3A%0A#{ERB::Util.url_encode(link)}"
//     when 'tg'
//       "tg://msg?text=#{ERB::Util.url_encode(text)}%3A%0A#{ERB::Util.url_encode(link)}"
//     when 'vb'
//       "viber://forward?text=#{ERB::Util.url_encode(text)}%3A%0A#{ERB::Util.url_encode(link)}"
//     end

{
  /* <SocialIcon
              bg={tg_gray}
              bgHover={tg_gray}
              href={`tg://msg?text=${encodeURIComponent('props.text')}`}
              target="blank"
            />
            <SocialIcon
              bg={tg_gray}
              bgHover={tg_gray}
              href={`https://api.whatsapp.com?text=${encodeURI('props.text')}`}
              target="blank"
            /> */
}
